const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDailyDoseReminderInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.999,
    height: 24,
    viewBox: "0 0 23.999 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "refil savings reminder icon",
    d: "M12 3a10.486 10.486 0 0 0-8.4 16.782l-1.88 1.877a.75.75 0 0 0 0 1.061l1.06 1.06a.75.75 0 0 0 1.061 0l1.877-1.88a10.444 10.444 0 0 0 12.562 0l1.88 1.879a.75.75 0 0 0 1.06 0l1.061-1.06a.75.75 0 0 0 0-1.061L20.4 19.78A10.488 10.488 0 0 0 12 3zm0 18.749a8.25 8.25 0 1 1 8.25-8.25 8.25 8.25 0 0 1-8.25 8.25zM4.5 0A4.5 4.5 0 0 0 0 4.5a4.444 4.444 0 0 0 .717 2.4l6.839-5.7A4.482 4.482 0 0 0 4.5 0zm15 0a4.483 4.483 0 0 0-3.055 1.2l6.838 5.7A4.446 4.446 0 0 0 24 4.5 4.5 4.5 0 0 0 19.5 0zM12 16.5a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5zm1.045-9h-2.091a.753.753 0 0 0-.745.825l.6 6a.75.75 0 0 0 .745.675h.891a.75.75 0 0 0 .745-.675l.6-6a.75.75 0 0 0-.745-.825z",
    style: {
      fill: "#093d4c"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyDoseReminderInactive);
export default __webpack_public_path__ + "static/media/daily_dose_reminder_inactive.a1d07edb7753b85be37f6645b55bf7cc.svg";
export { ForwardRef as ReactComponent };